<ng-container [caLocalizationScope]="localizationScope">
  <f-single-suggester-dropdown
    #suggester
    class="f-drawer-outclick-element"
    [items]="(suggesterClients$ | async) ?? []"
    [icon]="''"
    [minLength]="1"
    [hideCaret]="false"
    [isOutlineInput]="false"
    [valuePath]="'name'"
    [categoryPath]="'category'"
    [buttonTooltipPlacement]="tooltipPlacement"
    [btnStyle]="'btn-secondary ca-ticker-selector-btn'"
    [buttonText]="selectedClient() ? clientsNameFn(selectedClient()!) : ''"
    [buttonTooltip]="selectedClient() ? clientsNameFn(selectedClient()!) : ''"
    [activeItemValue]="selectedClient() ? clientsNameFn(selectedClient()!) : ''"
    [placeholder]="'searchForConsultantsClientPlaceholder' | caLocalize"
    [dropdownCssClass]="'suggester-dropdown-menu'"
    (select)="onSelect($event)"
  >
  </f-single-suggester-dropdown>
</ng-container>
